<template>
    <div>
        <!--调拨报表-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间" style="margin-right: 200px">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        
                    </Form>
                </Col>
            </Row>
        </header>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable">
            <template slot-scope="{ row, index }" slot="first">
                <span v-if="row.status==1" style="color: #00a1ff">已编辑</span>
                <span v-else style="color: #46bab2">采购单</span>
            </template>
             
        </Table>
        <div class="pageTotal"  >
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                columns: [
                    {title: '类型', key: 'status',align:'center',slot: 'first',},
                    {title: '单号', key: 'code',align:'center' },
                    {title: '修改时间', key: 'time' ,align:'center' },
                    {title: '库存数', key: 'num',align:'center'  },
                    {title: '修改人', key: 'updateUserName' ,align:'center' },
                    {title: '采购差价', key: 'errorCost' ,align:'center'},
                    {title: '原采购价', key: 'restorationCost' ,align:'center'},
                    {title: '现采购价', key: 'nowCost' ,align:'center'},
                    {title: '差价余额', key: 'surplus' ,align:'center'},
                ],
                data: [],
                
                page:{
                    total:0,
                    page:1,
                    rows:12
                },
                loadingTable:true
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(-7)
            this.valuedate[1] = this.nowTime
            this.selectGoodsCpriceRecord(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
        },

        methods: {
            //获取采购单
            selectGoodsCpriceRecord(startTime,endTime,page,rows){
                this.$Api.selectGoodsCpriceRecord({
                    goodsid: this.$route.query.id,//商品id
                    beginTime: startTime,//开始时间
                    endTime: endTime,//结束时间
                    page: page,//页数
                    rows: rows//每页记录数
                }).then(res => {
                    if(res.code==200){
                        this.data=res.data
                        this.page.total = res.count
                        this.loadingTable=false
                        
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            
            modifyTime(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.selectGoodsCpriceRecord(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            },
            onGongPageTotal(num){
                this.selectGoodsCpriceRecord(this.valuedate[0],this.valuedate[1],num,this.page.rows)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
    .tableFirst{
        color: #ff5e5e;
    }
</style>